import { Geometry } from "../../../sharedComponents/imageAnnotation/components/Annotation";

export const getCoordPercentage = (e: React.MouseEvent<HTMLElement>) => ({
    x: (e.nativeEvent.offsetX / e.currentTarget.offsetWidth) * 100,
    y: (e.nativeEvent.offsetY / e.currentTarget.offsetHeight) * 100,
});

export const getCoordStylesPositions = (geometry: Geometry) => ({
    left: `${geometry.x}%`,
    top: `${geometry.y + geometry.height}%`,
});
